import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiCaller } from './honeycomb-api/api-caller';
import { RequestParams } from './honeycomb-api/assets/request-params.model';
import { HttpMethod } from './honeycomb-api/assets/http-method.enum';
import { RequestParam } from './honeycomb-api/assets/request-param.model';
import { RequestParamType } from './honeycomb-api/assets/request-param-type.enum';

export interface DataExecuteRequest {
    procedureName: string;
    parameters: { [key: string]: any };
}

@Injectable({
    providedIn: 'root'
})
export class DataService {

    private readonly controllerRoute = 'api/TenantAdmin/data';

    constructor(private apiCaller: ApiCaller) {}

    /** POST /api/TenantAdmin/data/execute — runs any stored procedure and returns the result rows. */
    execute(procedureName: string, parameters: { [key: string]: any } = {}): Observable<any[]> {
        const request: DataExecuteRequest = { procedureName, parameters };
        const requestParams = new RequestParams('execute', HttpMethod.POST, [
            new RequestParam('request', RequestParamType.BODY, request)
        ]);
        return this.apiCaller.request(this.controllerRoute, requestParams) as Observable<any[]>;
    }
}
